import { ErrorBase } from './ErrorBase';

export class BadRequestError extends ErrorBase {
  constructor({ message, cause }: { message: string; cause: Error }) {
    super({ message, cause });
    this.name = 'BadRequestError';
  }
}
